var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 8.75V11.0833H2.91667V8.75H11.0833ZM11.6667 7.58333H2.33333C2.0125 7.58333 1.75 7.84583 1.75 8.16667V11.6667C1.75 11.9875 2.0125 12.25 2.33333 12.25H11.6667C11.9875 12.25 12.25 11.9875 12.25 11.6667V8.16667C12.25 7.84583 11.9875 7.58333 11.6667 7.58333ZM4.08333 10.7917C3.605 10.7917 3.20833 10.4008 3.20833 9.91667C3.20833 9.4325 3.605 9.04167 4.08333 9.04167C4.56167 9.04167 4.95833 9.4325 4.95833 9.91667C4.95833 10.4008 4.5675 10.7917 4.08333 10.7917ZM11.0833 2.91667V5.25H2.91667V2.91667H11.0833ZM11.6667 1.75H2.33333C2.0125 1.75 1.75 2.0125 1.75 2.33333V5.83333C1.75 6.15417 2.0125 6.41667 2.33333 6.41667H11.6667C11.9875 6.41667 12.25 6.15417 12.25 5.83333V2.33333C12.25 2.0125 11.9875 1.75 11.6667 1.75ZM4.08333 4.95833C3.605 4.95833 3.20833 4.5675 3.20833 4.08333C3.20833 3.59917 3.605 3.20833 4.08333 3.20833C4.56167 3.20833 4.95833 3.605 4.95833 4.08333C4.95833 4.56167 4.5675 4.95833 4.08333 4.95833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.325091e227412a8b8ea72f4eaa16b41a.svg";
export { ForwardRef as ReactComponent };